<template>
  <ContentPage back>
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">
        {{ currentRequest.name }}
        <v-icon 
          color="#F47C02" class="pb-1 ml-1" 
          v-if="currentRequest.source_type == 'from_consumer'"
        >
          mdi-qrcode
        </v-icon>
      </div>
    </template>

    <div style="position: relative; overflow-x: hidden;">
      <Section>
        <template #header>
          <div class="mr-auto">
            <strong style="color:black">Needed Help With</strong>
          </div>
        </template>
        <div class="pl-2" v-if="prettyStructureType">
          {{ prettyStructureType }} - {{ currentRequest.service.service }}
        </div>
        <div class="pl-2" v-else>
          {{ currentRequest.service.service }}
        </div>
      </Section>

      <Notes :request="currentRequest" />
      <Contact :request="currentRequest" />
      <Leads :request="currentRequest" />

      <div v-if="!currentRequest.is_valid" class="overlay">Disqualified</div>
    </div>
  </ContentPage>
</template>

<script>

import { ContentPage, Section } from '@/components/pages'
import Contact from './sections/Contact'
import Notes from './sections/Notes'
import Leads from './sections/Leads'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    ContentPage,
    Contact,
    Notes,
    Leads,
    Section,
  },

  props: ['id'],

  computed: {
    ...mapGetters('auth', ['settings']),
    ...mapGetters('customer_requests', ['currentRequest']),

    prettyStructureType() {
      if (!this.settings?.structure_types)
        return ""

      return this.settings.structure_types[this.currentRequest.structure_type]
    },
  },
  
  methods: {
    ...mapActions('auth', ['loadSettings']),
    ...mapActions('customer_requests', ['loadCurrent']),

  },

  async created() {
    const p = this.loadSettings()
    await this.loadCurrent (this.id)
    await p
  },
}

</script>

<style scoped>
  .overlay {
    position: absolute;
    top: 0px;
    left: 0px;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 48px;
    font-weight: bold;
    color: rgba(0,0,0,0.3);
    transform: rotate(-45deg);
    text-align: center;
    overflow: hidden;
    pointer-events: none;
  }
</style>